import React, { ReactNode } from 'react';
import classNames from 'classnames';
import css from './Count.module.css';
import { BarChartOutlined } from '@ant-design/icons';

type Props = Omit<React.HTMLProps<HTMLDivElement>, 'value'> & {
  className?: string;
  value?: ReactNode | JSX.Element | number | string;
  icon?: ReactNode;
};

export const Count = ({ className, value, icon, ...rest }: Props) => {
  return (
    <div className={classNames(css.container, className)} {...rest}>
      <div className={css.icon}>{icon || <BarChartOutlined />}</div>
      <span className={css.count}>{value}</span>
    </div>
  );
};
